module.exports = __webpack_public_path__ + "img/izibox.d4c8f481.jpg";